export default "__VITE_ASSET__4218a134__"